import { render, staticRenderFns } from "./CpE_PageEdit.vue?vue&type=template&id=60cdc9b3"
import script from "./CpE_PageEdit.vue?vue&type=script&lang=js"
export * from "./CpE_PageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports